// extracted by mini-css-extract-plugin
export default {"container":"pq-z","heading":"qq-z","text":"rq-z","info":"sq-z","link":"tq-z","fullMaxWidth":"uq-z"};